<template>
    <v-layout class="floating-actions" align-center justify-center :class="{ left, top, right, bottom }">
        <v-flex shrink>
            <slot />
        </v-flex>
    </v-layout>
</template>
<script>
export default {
    props: {
        left: { type: Boolean, default: false, },
        top: { type: Boolean, default: false, },
        right: { type: Boolean, default: false, },
        bottom: { type: Boolean, default: false, },
    }
}
</script>
<style scoped>
.floating-actions {
    position: fixed;
    height: 0;
    z-index: 2;
    margin: auto;
}
.floating-actions.left {
    left: 0;
}
.floating-actions.top {
    top: 0;
}
.floating-actions.right {
    right: 0;
}
.floating-actions.bottom {
    bottom: 0;
}
</style>